import {getDynamicCurrentYearExportLabel} from './getDynamicCurrentYearExportLabel';

/**
 * Gets the dynamic next year export label text for learning path edit view
 * Always shows one year ahead of the current year export label
 * @returns String like "Export 8/15/2026"
 */
export const getDynamicNextYearExportLabel = (): string => {
  // Get the current year export label and extract the year
  const currentYearLabel = getDynamicCurrentYearExportLabel();
  const currentYearMatch = currentYearLabel.match(/(\d{4})$/);

  if (!currentYearMatch) {
    // Fallback to original logic if regex fails
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const august15CurrentYear = new Date(currentYear, 7, 15);

    if (currentDate <= august15CurrentYear) {
      return `Export 8/15/${currentYear + 1}`;
    } else {
      return `Export 8/15/${currentYear + 2}`;
    }
  }

  const currentTargetYear = parseInt(currentYearMatch[1], 10);
  const nextTargetYear = currentTargetYear + 1;

  return `Export 8/15/${nextTargetYear}`;
};
